"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccountSwitcher = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _styled = require("./styled");

var _AccountCard = _interopRequireDefault(require("./AccountCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var sortAccounts = function sortAccounts(a, b) {
  if (a.active) {
    return -1;
  } else if (b.active) {
    return 1;
  }

  return 0;
};

var AccountSwitcher =
/*#__PURE__*/
function (_Component) {
  _inherits(AccountSwitcher, _Component);

  function AccountSwitcher(props) {
    var _this;

    _classCallCheck(this, AccountSwitcher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AccountSwitcher).call(this, props));
    _this.state = {
      searchValue: ''
    };
    return _this;
  }

  _createClass(AccountSwitcher, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      document.body.scrollTop = 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          accounts = _this$props.accounts,
          switchUserAccount = _this$props.switchUserAccount,
          currentProduct = _this$props.currentProduct;
      var searchValue = this.state.searchValue;
      var sortedAccounts = accounts.sort(sortAccounts);
      var filteredAccounts = sortedAccounts.filter(function (account) {
        var uppercaseAccountName = account.name.toUpperCase();
        var uppercaseSearchValue = searchValue.toUpperCase();
        return uppercaseAccountName.indexOf(uppercaseSearchValue) > -1;
      });
      return _react["default"].createElement(_styled.AccountsListModalContainer, null, _react["default"].createElement(_styled.AccountCardsContainer, null, _react["default"].createElement(_styled.AccountSearch, {
        placeholder: "Search for an account...",
        value: searchValue,
        onChange: function onChange(e) {
          return _this2.setState({
            searchValue: e.target.value
          });
        }
      }), _react["default"].createElement(_styled.AccountCardsScrollContainer, null, _react["default"].createElement(_reactPerfectScrollbar["default"], null, filteredAccounts.map(function (account) {
        return _react["default"].createElement(_AccountCard["default"], {
          key: account.account_id,
          active: account.active,
          name: account.name,
          image: account.image,
          onClick: function onClick() {
            return !account.active && switchUserAccount(account.account_id, currentProduct);
          }
        });
      })))));
    }
  }]);

  return AccountSwitcher;
}(_react.Component);

exports.AccountSwitcher = AccountSwitcher;
var _default = AccountSwitcher;
exports["default"] = _default;

//# sourceMappingURL=AccountSwitcher.js.map